import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import EditorialBand from '../../components/public/EditorialBand.component';
import EditorialBulletList from '../../components/public/EditorialBulletList.component';
import EditorialCardGrid from '../../components/public/EditorialCardGrid.component';
import EditorialHero from '../../components/public/EditorialHero.component';
import EditorialQuote from '../../components/public/EditorialQuote.component';
import EditorialSteps from '../../components/public/EditorialSteps.component';
import {
  OUR_PRODUCTS_CARDS,
  OUR_PRODUCTS_FOUNDER,
  OUR_PRODUCTS_HERO,
  OUR_PRODUCTS_PARTNERS,
  OUR_PRODUCTS_STEPS,
} from '../../constants/our-products-content.constants';
import Meta from '../../../utils/metaDescription';

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    fontSize: 'clamp(1.5rem, 4vw, 2.1rem)',
    lineHeight: 1.2,
    marginBottom: '2rem',
    textAlign: 'center',
    color: theme.palette.client.primary.extraDark,
  },
  photograph: {
    display: 'block',
    width: '100%',
    maxWidth: 600,
    margin: '0 auto 2.5rem',
    borderRadius: 16,
  },
  label: {
    display: 'block',
    width: '100%',
    maxWidth: 120,
    margin: '0 auto',
  },
}));

const OurProductsView: React.FC = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Meta page="produits" />

      <EditorialBand ground="cream" underFloatingNav>
        <EditorialHero
          title={OUR_PRODUCTS_HERO.title}
          lead={OUR_PRODUCTS_HERO.lead}
          highlight={OUR_PRODUCTS_HERO.highlight}
        />
      </EditorialBand>

      <EditorialBand ground="tint">
        <EditorialSteps steps={OUR_PRODUCTS_STEPS} />
      </EditorialBand>

      <EditorialBand ground="plain">
        <EditorialCardGrid cards={OUR_PRODUCTS_CARDS} columns={3} />
      </EditorialBand>

      <EditorialBand ground="solid">
        <EditorialQuote content={OUR_PRODUCTS_FOUNDER} onSolid />
      </EditorialBand>

      <EditorialBand ground="plain">
        <Typography component="h2" className={classes.sectionTitle}>
          {OUR_PRODUCTS_PARTNERS.title}
        </Typography>

        <img
          className={classes.photograph}
          src={OUR_PRODUCTS_PARTNERS.photograph}
          alt={OUR_PRODUCTS_PARTNERS.photographAlt}
          loading="lazy"
        />

        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} sm={3} md={2}>
            <img className={classes.label} src={OUR_PRODUCTS_PARTNERS.label} alt={OUR_PRODUCTS_PARTNERS.labelAlt} />
          </Grid>

          <Grid item xs={12} sm={9} md={10}>
            <EditorialBulletList items={OUR_PRODUCTS_PARTNERS.certifications} />
          </Grid>
        </Grid>
      </EditorialBand>
    </React.Fragment>
  );
};

export default OurProductsView;
